import { MapWidgetMixpanelEvent, MixpanelEvent } from './mixpanel.types';

/**
 * All the events that are sent to Mixpanel should be defined here.
 * Events should follow the MixpanelEvent type and be in title case.
 *
 */

export const READING_ORDER_EDITED: MixpanelEvent = {
  eventName: 'Reading Order Edited',
};

export const READING_ORDER_TAB_OPENED: MixpanelEvent = {
  eventName: 'Reading Order Tab Opened',
  from: {
    fileMenu: 'File Menu',
    accessibilityCheckerTab: 'Accessibility Checker Tab',
  },
};
export const VISUAL_SIMULATOR_TAB_OPENED: MixpanelEvent = {
  eventName: 'Visual Simulator Tab Opened',
  from: {
    fileMenu: 'File Menu',
    colorMenu: 'Color Menu',
  },
};
export const ALT_TEXT_MODAL_OPENED: MixpanelEvent = {
  eventName: 'Alt Text Modal Opened',
  from: {
    AltTag: 'Alt Tag',
    AccessibilyChecker: 'Accessibility Checker',
  },
};
export const ALT_TEXT_LABELS_APPLIED: MixpanelEvent = {
  eventName: 'Alt Text Labels Applied',
};
export const ALT_TEXT_EDITED: MixpanelEvent = { eventName: 'Alt Text Edited' };
export const ALT_TEXT_GENERATED: MixpanelEvent = { eventName: 'Alt Text Generated' };
export const ALT_TEXT_GENERATION_ERROR: MixpanelEvent = { eventName: 'Alt Text Generation Error' };
export const HELP_OPENED: MixpanelEvent = {
  eventName: 'Help Opened',
  from: {
    colorMenu: 'Color Menu',
    readingOrderMenu: 'Reading Order Menu',
    accessibilityChecker: 'Accessibility Checker',
  },
};
export const DOCUMENT_LANGUAGE_MODAL_OPENED: MixpanelEvent = {
  eventName: 'Document Language Modal Opened',
  from: {
    fileMenu: 'File Menu',
    accessibilityChecker: 'Accessibility Checker',
  },
};
export const DOCUMENT_LANGUAGE_EDITED: MixpanelEvent = { eventName: 'Document Language Edited' };
export const TEXT_TAG_EDITED: MixpanelEvent = {
  eventName: 'Text Tag Edited',
  from: {
    accessibilityChecker: 'Accessibility Checker',
  },
};
export const ACCESSIBILITY_CHECKER_OPENED: MixpanelEvent = {
  eventName: 'Accessibility Checker Opened',
  from: {
    navbar: 'Navbar',
    fileMenu: 'File Menu',
  },
};
export const ACCESSIBILITY_AUTO_CHECKED: MixpanelEvent = { eventName: 'Accessibility Auto Checked' };
export const ACCESSIBILITY_MANUAL_CHECKED: MixpanelEvent = { eventName: 'Accessibility Manual Checked' };
export const TABLE_HEADER_EDITED: MixpanelEvent = { eventName: 'Table Header Edited' };
export const IMAGE_UPLOADED: MixpanelEvent = { eventName: 'Image Uploaded' };
export const COLOR_PICKER_CONTRAST_OPENED: MixpanelEvent = { eventName: 'Color Contrast Opened' };
export const TEXT_CREATED: MixpanelEvent = {
  eventName: 'Text Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    KeyboardShortcut: 'Keyboard Shortcut',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
export const TEXT_COPIED: MixpanelEvent = {
  eventName: 'Text Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const TEXT_DELETED: MixpanelEvent = {
  eventName: 'Text Deleted',
};
export const OPEN_SHARE_MODAL: MixpanelEvent = {
  eventName: 'Open Share Modal',
  from: {
    ShareButton: 'Editor Share Button',
    DownloadButton: 'Editor Download Button',
  },
};
export const DESIGN_PREVIEW: MixpanelEvent = {
  eventName: 'Preview Design',
  from: {
    previewButton: 'Editor Preview Button',
    shareButton: 'Editor Share Button',
    inContextButton: 'Editor In-Context Preview Button',
    settingsButton: 'Editor Widget Settings Button',
  },
  type: {
    flipBook: 'Flip Book',
  },
};
export const TEXT_EDITED: MixpanelEvent = {
  eventName: 'Text Edited',
  styling_property: {
    Font: 'Font Family',
    Effect: 'Effect',
  },
  styling_value: {
    Shadow: 'Shadow',
    Glow: 'Glow',
    Outline: 'Outline',
    Offset: 'Offset',
    Repeat: 'Repeat',
    Thickness: 'Thickness',
    Intensity: 'Intensity',
    Transparency: 'Transparency',
    Direction: 'Direction',
    Blur: 'Blur',
    Curve: 'Curve',
    None: 'None',
  },
};
export const COLOR_EDITED: MixpanelEvent = {
  eventName: 'Color Edited',
  from: {
    ColorPicker: 'Color Picker',
    Hex: 'Hex',
    EyeDropper: 'Eye Dropper',
    Swatch: 'Swatch',
    BrandkitColor: 'Brand Swatch',
  },
};
export const PALETTE_APPLIED: MixpanelEvent = {
  eventName: 'Palette Applied',
  type: {
    Generic: 'Generic',
    BrandKit: 'Brand Kit',
  },
  from: {
    AllPages: 'All Pages',
    SinglePage: 'Single Page',
  },
};
export const FONT_STYLE_APPLIED: MixpanelEvent = {
  eventName: 'Font Style Applied',
  type: {
    Generic: 'Generic',
    BrandKit: 'Brand Kit',
  },
};
export const CANVAS_ZOOM: MixpanelEvent = {
  eventName: 'Canvas Zoom Changed',
  from: {
    ZoomButton: 'Zoom Button',
    ShareZoomButton: 'Share Zoom Button',
    KeyboardShortCut: 'Keyboard ShortCut',
    ZoomInput: 'Zoom Input',
    ShareZoomInput: 'Share Zoom Input',
  },
};
export const PAGE_SIZE_EDITED: MixpanelEvent = {
  eventName: 'Page Size Edited',
  standardSize: {
    Letter: 'Letter',
    Legal: 'Legal',
    Tabloid: 'Tabloid',
    A3: 'A3',
    A4: 'A4',
    A5: 'A5',
  },
  displayUnit: {
    Px: 'px',
    Inch: 'in',
    Cm: 'cm',
  },
  magicResize: {
    True: 'True',
    False: 'False',
  },
};
export const PAGE_DELETED: MixpanelEvent = {
  eventName: 'Page Deleted',
};

export const PAGE_ADDED: MixpanelEvent = {
  eventName: 'Page Added',
  from: {
    templates: 'Templates',
    project: 'Project',
    multiPageMenu: 'Multipage Menu',
  },
  type: {
    design: 'Design',
    blank: 'Blank',
    template: 'Template',
    DesignAI: 'DesignAI',
  },
};

export const BACKGROUND_FILL_EDITED: MixpanelEvent = {
  eventName: 'Background Fill Edited',
  type: {
    Solid: 'solid',
    Gradient: 'gradient',
  },
};

export const GRADIENT_EDITED: MixpanelEvent = {
  eventName: 'Gradient Edited',
  styling_property: {
    GradientType: 'Gradient Type',
  },
  styling_value: {
    Horizontal: 'Horizontal',
    Vertical: 'Vertical',
    Diagonal_1: 'Diagonal_1',
    Diagonal_2: 'Diagonal_2',
    Radial: 'Radial',
  },
};

export const PATTERN_APPLIED: MixpanelEvent = {
  eventName: 'Pattern Applied',
};
export const PATTERN_REMOVED: MixpanelEvent = {
  eventName: 'Pattern Removed',
};

// Widget Creation and Deletion Events
export const SHAPE_CREATED: MixpanelEvent = {
  eventName: 'Shape Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    Replace: 'Replace',
    KeyboardShortcut: 'Keyboard Shortcut',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
  border: {
    None: 'None',
    Solid: 'Solid',
    Dashed: 'Dashed',
    Dotted: 'Dotted',
  },
};
export const SHAPE_COPIED: MixpanelEvent = {
  eventName: 'Shape Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const SHAPE_REPLACED: MixpanelEvent = {
  eventName: 'Shape Replaced',
};
export const SHAPE_DELETED: MixpanelEvent = { eventName: 'Shape Deleted' };
export const LINE_CREATED: MixpanelEvent = {
  eventName: 'Line Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    KeyboardShortcut: 'Keyboard Shortcut',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
    FlowModePort: 'Flow Mode Port',
  },
  orientation: {
    Horizontal: 'Horizontal',
    Vertical: 'Vertical',
    Diagonal: 'Diagonal',
  },
  lineEdge: {
    None: 'None',
    BasicArrow: 'BasicArrow',
  },
  type: {
    Straight: 'Straight',
    Stepped: 'Stepped',
    Curved: 'Curved',
  },
};
export const LINE_COPIED: MixpanelEvent = {
  eventName: 'Line Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const PORT_NODE_CONNECTED: MixpanelEvent = {
  eventName: 'Port/Node Connected',
};
export const PORT_NODE_DISCONNECTED: MixpanelEvent = {
  eventName: 'Port/Node Disconnected',
};
export const NODE_ADDED: MixpanelEvent = {
  eventName: 'Node Added',
};
export const NODE_CREATED: MixpanelEvent = {
  eventName: 'Node Created',
  from: {
    Modal: 'Modal',
    InContextMenu: 'In-Context Duplication',
    Duplication: 'Duplication',
    KeyboardPaste: 'Keyboard Paste',
    ContextMenu: 'Context Menu Paste',
  },
};
export const LINE_DELETED: MixpanelEvent = { eventName: 'Line Deleted' };
export const ICON_CREATED: MixpanelEvent = {
  eventName: 'Icon Created',
  from: {
    Pack: 'Pack',
    Search: 'Search',
    Replace: 'Replace',
    Duplication: 'Duplication',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
    Recommended: 'Recommended',
  },
};
export const ICON_REPLACED: MixpanelEvent = {
  eventName: 'Icon Replaced',
  category: {
    ReplacedByImage: 'Image',
    ReplacedByIcon: 'Icon',
  },
};
export const ICON_COPIED: MixpanelEvent = {
  eventName: 'Icon Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const ICON_DELETED: MixpanelEvent = { eventName: 'Icon Deleted' };
export const IMAGE_PANEL_OPENED: MixpanelEvent = { eventName: 'Image Panel Opened' };
export const IMAGE_CREATED: MixpanelEvent = {
  eventName: 'Image Created',
  from: {
    Search: 'Search',
    Replace: 'Replace',
    Upload: 'Upload',
    Duplication: 'Duplication',
    Brand: 'Brand Kit',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
export const GIF_CREATED: MixpanelEvent = {
  eventName: 'GIF Created',
  from: {
    Search: 'Search',
    Replace: 'Replace',
  },
};
export const IMAGE_COPIED: MixpanelEvent = {
  eventName: 'Image Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const IMAGE_EDITED: MixpanelEvent = {
  eventName: 'Image Edited',
  image_effect: {
    Filter: 'Filter',
    Adjust: 'Adjust',
    ColorOverlay: 'Color Overlay',
    DropShadow: 'Drop Shadow',
    ReturnToOriginal: 'Return to Original',
    RemoveBackground: 'Remove Background',
  },
  color_overlay: {
    Off: 'Off',
    On: 'On',
  },
};
export const IMAGE_REPLACED: MixpanelEvent = {
  eventName: 'Image Replaced',
  category: {
    ReplacedByImage: 'Image',
    ReplacedByIcon: 'Icon',
  },
};
export const IMAGE_DELETED: MixpanelEvent = {
  eventName: 'Image Deleted',
  from: {
    UploadModal: 'Upload Modal',
  },
};
export const IMAGE_FOLDER_DELETED: MixpanelEvent = {
  eventName: 'Image Folder Deleted',
};
export const IMAGE_FOLDER_CREATED: MixpanelEvent = {
  eventName: 'Image Folder Created',
};
export const IMAGE_FOLDER_MODAL: MixpanelEvent = {
  eventName: 'Image Upload Modal Opened',
};

export const INTERACTIVE_ELEMENTS_CREATED: MixpanelEvent = {
  eventName: 'Interactive Elements Created',
  elementType: {
    InteractiveList: 'interactiveList',
    MultipleChoices: 'multipleChoices',
    ShortQuestion: 'shortQuestion',
    LongQuestion: 'longQuestion',
    Signature: 'signature',
    SelectionField: 'selectionField',
    Label: 'label',
  },
};

export const QUIZZES_EDITED: MixpanelEvent = {
  eventName: 'Quizzes Edited',
  edit_type: {
    on: 'Multiple Selection On',
    off: 'Multiple Selection Off',
  },
};

export const QUIZZES_DELETED: MixpanelEvent = {
  eventName: 'Quizzes Deleted',
};

export const FORM_DELETED: MixpanelEvent = {
  eventName: 'Form Deleted',
  feature: {
    Signature: 'Signature',
  },
};

export const ELEMENTS_OPEN: MixpanelEvent = {
  eventName: 'Elements Opened',
  types: {
    textBlocks: 'Text Blocks',
    signatures: 'Signatures',
    qrCode: 'QR Code',
    lists: 'Lists',
    imageFrames: 'Image Frames',
    imageGrids: 'Image Grids',
    videoEmbed: 'Video Embed',
    gifs: 'GIFs',
    gifsReplace: 'GIFs',
    label: 'Label',
    interactiveList: 'Interactive List',
    multipleChoices: 'Multiple Choices',
    forms: 'Forms',
  },
};

export const TABLE_CREATED: MixpanelEvent = {
  eventName: 'Table Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
// A table was edited by the user
export const TABLE_EDITED: MixpanelEvent = {
  eventName: 'Table Edited',
  insert_type: {
    Row: 'Row',
    Column: 'Column',
  },
  delete_type: {
    Row: 'Row',
    Column: 'Column',
  },
};
export const TABLE_COPIED: MixpanelEvent = {
  eventName: 'Table Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const TABLE_DELETED: MixpanelEvent = { eventName: 'Table Deleted' };
export const CHART_PANEL_OPENED: MixpanelEvent = { eventName: 'Chart Panel Opened' };
export const CHART_CREATED: MixpanelEvent = {
  eventName: 'Chart Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
export const CHART_COPIED: MixpanelEvent = {
  eventName: 'Chart Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const CHART_EDITED: MixpanelEvent = {
  eventName: 'Chart Edited',
  styling_property: {
    ChartSwap: 'Chart Swap',
    Labels: 'Labels',
  },
  styling_value: {
    Off: 'Off', // For non axis labels
    On: 'On', // For non axis labels
    XAxisLabelsOn: 'XAxisLabelsOn',
    XAxisLabelsOff: 'XAxisLabelsOff',
    YAxisLabelsOn: 'YAxisLabelsOn',
    YAxisLabelsOff: 'YAxisLabelsOff',
    DataLabelsOn: 'DataLabelsOn',
    DataLabelsOff: 'DataLabelsOff',
    ValueLabelsOn: 'ValueLabelsOn',
    ValueLabelsOff: 'ValueLabelsOff',
    CategoryLabelsOn: 'CategoryLabelsOn',
    CategoryLabelsOff: 'CategoryLabelsOff',
  },
  chart_type: {
    Area: 'Area',
    Bar: 'Bar',
    Column: 'Column',
    DonutPie: 'DonutPie',
    HalfPie: 'HalfPie',
    HalfDonutPie: 'HalfDonutPie',
    Histogram: 'Histogram',
    Line: 'Line',
    Pie: 'Pie',
    StackedArea: 'StackedArea',
    StackedBar: 'StackedBar',
    StackedColumn: 'StackedColumn',
    WordCloud: 'WordCloud',
    Funnel: 'Funnel',
    Pyramid: 'Pyramid',
    AreaSplineChart: 'AreaSpline',
    StackedAreaSplineChart: 'StackedAreaSpline',
    SingleLine: 'SingleLine',
    CloudBubble: 'CloudBubble',
    ScatterPlotChart: 'ScatterPlotChart',
    SplineChart: 'Spline',
    SingleSpline: 'SingleSpline',
    TreeMap: 'TreeMap',
  },
};
export const CHART_DELETED: MixpanelEvent = { eventName: 'Chart Deleted' };
export const WIDGETS_DELETED: MixpanelEvent = { eventName: 'Widgets Deleted' };
export const QR_CODE_DELETED: MixpanelEvent = { eventName: 'QR Code Deleted' };
export const QR_CODE_CREATED: MixpanelEvent = {
  eventName: 'QR Code Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
export const SHARE_QR_CODE: MixpanelEvent = {
  eventName: 'Share',
  copy: 'Copy QR Code',
  download: 'Download QR Code',
};

export const SIGNATURE_MODAL_OPENED: MixpanelEvent = {
  eventName: 'Signature Modal Opened',
};
export const SIGNATURE_EDITED: MixpanelEvent = {
  eventName: 'Signature Edited',
};
export const SIGNATURE_CREATED: MixpanelEvent = {
  eventName: 'Signature Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};

export const VIDEO_EMBED_DELETED: MixpanelEvent = { eventName: 'Video Embed Deleted' };

export const LOTTIE_DELETED: MixpanelEvent = { eventName: 'GIF Deleted' };

export const CLICKED_ON_GROUP: MixpanelEvent = {
  eventName: 'Clicked On Group',
  type: {
    group: 'group',
    ungroup: 'ungroup',
  },
};

// ELEMENTS / GROUP WIDGETS
export const ELEMENT_CREATED: MixpanelEvent = {
  eventName: 'Elements Created',
  elementsId: {
    videoEmbed: 'video_embed',
    gifs: 'gifs',
  },
  from: {
    LeftPanel: 'Left Panel',
  },
};

// MAP WIDGET
export const MAP_CREATED: MixpanelEvent = {
  eventName: 'Map Created',
  from: {
    Duplication: 'Duplication',
    Popular: 'Popular',
    Search: 'Search',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
export const MAP_COPIED: MixpanelEvent = {
  eventName: 'Map Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};

export const MAP_EDITED: MapWidgetMixpanelEvent = {
  eventName: 'Map Edited',
  stylingProperty: {
    ScaleType: 'Scale Type', // Todo: add in scaleType feature
    MapStyle: 'Map Style',
    Labels: 'Labels',
    LabelFormat: 'Label Format',
    Legend: 'Legend',
    AltText: 'Alt Text',
  },
  stylingValue: {
    ScaleTypeGradient: 'Gradient',
    ScaleTypeSteps: 'Steps',
    CustomRangeOn: 'Custom Range On',
    CustomRangeOff: 'Custom Range Off',
    ColorPresets: 'Color Presets',
    NameLabelsOn: 'Name Labels On',
    NameLabelsOff: 'Name Labels Off',
    ValueLabelsOn: 'Value Labels On',
    ValueLabelsOff: 'Value Labels Off',
    LabelFormatName: 'Name',
    LabelFormatValue: 'Value',
    LegendOn: 'On',
    LegendOff: 'Off',
    AltTextDecorative: 'Decorative',
    AltTextEdited: 'Alt Text Edited',
  },
  mapType: {
    ChoroplethSteps: 'Choropleth Steps',
    ChoroplethGradient: 'Choropleth Gradient',
    Bubble: 'Bubble',
    Monochrome: 'Monochrome',
  },
};
export const MAP_DELETED: MapWidgetMixpanelEvent = {
  eventName: 'Map Deleted',
  mapType: {
    ChoroplethSteps: 'Choropleth Steps',
    ChoroplethGradient: 'Choropleth Gradient',
    Bubble: 'Bubble',
    Monochrome: 'Monochrome',
  },
};
export const MAP_IMPORT: MixpanelEvent = {
  eventName: 'Map Imported',
  map_import_status: {
    pass: 'Pass',
    fail: 'Fail',
  },
};
export const AUTO_BRAND_OPENED: MixpanelEvent = {
  eventName: 'Autobrand Opened',
  from: {
    colorMenu: 'Color menu',
    backgroundPanel: 'Background panel',
    brandKitTab: 'Brand kit tab',
    banner: 'Auto-brand banner',
  },
};
export const NEW_BRAND_ADDED: MixpanelEvent = {
  eventName: 'Add New Brand Kit',
};
export const AUTO_BRAND_ADDED: MixpanelEvent = {
  eventName: 'Autobrand Added',
};
export const AUTO_BRAND_SKIPPED: MixpanelEvent = {
  eventName: 'Autobrand Skipped',
};
export const AUTO_BRAND_DISCARD: MixpanelEvent = {
  eventName: 'Autobrand Discarded',
};
export const AUTO_BRAND_FONTS: MixpanelEvent = {
  eventName: 'Brand fonts fetched',
};
// Critical events
export const DOWNLOAD: MixpanelEvent = { eventName: 'Download' };
export const UPGRADE: MixpanelEvent = {
  eventName: 'Click On Upgrade',
  feature: {
    PrivateShare: 'Private Share',
    FreeShareModal: 'Free Share Modal',
    DownloadButton: 'Download',
    DownloadPremium: 'Download Premium',
    DownloadBusiness: 'Download Business',
    TemplatePremium: 'Editor Template Premium',
    TemplateBusiness: 'Editor Template Business',
    ImageUploadLimit: 'Image Upload Limit',
    HeaderButtonEditor: 'Header Button',
    Brandkit: 'brand kit',
    UploadFolder: 'Upload Folder',
    Style: 'Style',
    CustomFont: 'Custom Font',
    BrandkitColor: 'Brand Kit (Colour)',
    BrandkitPalette: 'Brand Kit (Palette)',
    BrandkitFont: 'Brand Kit (Font)',
    BrandKitLogo: 'Brand Kit (Logo)',
    BrandKitIcon: 'Brand Kit (Icon)',
    BrandKitImage: 'Brand Kit (Image)',
    PremiumChart: 'Premium Chart',
    PremiumMap: 'Premium Map',
    DesignAIGeneration: 'DesignAI Text Generation',
    Elements: 'Elements',
    Share: 'Share',
    Preview: 'Preview',
    Embed: 'Embed',
    SaveAsMyTemplate: 'Save as My Template',
    SaveAsTeamTemplate: 'Save as Team Template',
    InviteTeamMember: 'Invite Member',
    HRTeams: 'HR Dashboard',
    Signature: 'Signature',
  },
};
export const COPY_SHARE_LINK: MixpanelEvent = { eventName: 'Share' };

export const ICON_PACK_OPENED: MixpanelEvent = {
  eventName: 'Icon Pack Opened',
};

// Zendesk chat
export const CHAT_OPEN: MixpanelEvent = { eventName: 'Click on Chat Icon' };
export const CHAT_CLOSE: MixpanelEvent = { eventName: 'Hide Chat' };

// Card generator
export const DESIGN_GENERATED: MixpanelEvent = {
  eventName: 'DesignAI Generated',
  templateCategoryName: {
    Cards: 'cards',
    Infographics: 'infographics',
    Wrappeds: 'wrappeds',
  },
  actionTypeCategoryName: {
    Generate: 'Generate',
    Regenerate: 'Regenerate',
    Retry: 'Retry',
    Stop: 'Stop',
  },
};

export const DESIGN_GENERATED_SUCCESS: MixpanelEvent = {
  eventName: 'DesignAI Generated Success',
};

export const DESIGN_GENERATED_FAIL: MixpanelEvent = {
  eventName: 'DesignAI Generated Fail',
};

export const DESIGN_GENERATED_STOP: MixpanelEvent = {
  eventName: 'DesignAI Generated Stop',
};

export const DESIGN_GENERATED_CUSTOMIZE: MixpanelEvent = {
  eventName: 'DesignAI Generated Customize',
  from: {
    Preview: 'Preview',
    StatusBar: 'Status Bar',
    MobileButton: 'Mobile Button',
  },
};

export const DESIGN_GENERATED_RETRY: MixpanelEvent = {
  eventName: 'DesignAI Generated Retry',
  from: {
    StatusBar: 'Status Bar',
    MobileButton: 'Mobile Button',
  },
};

// AI Name Generator
export const AI_NAME_GENERATED: MixpanelEvent = {
  eventName: 'AI Name Generated',
  actionTypeCategoryName: {
    Generate: 'Generate',
    Regenerate: 'Regenerate',
    Retry: 'Retry',
  },
};

export const AI_NAME_GENERATED_SUCCESS: MixpanelEvent = {
  eventName: 'AI Name Generated Success',
};

export const AI_NAME_GENERATED_FAIL: MixpanelEvent = {
  eventName: 'AI Name Generated Fail',
};

// Data import
export const CHART_DATA_IMPORT: MixpanelEvent = {
  eventName: 'Chart Data Imported',
  data_import_status: {
    pass: 'Pass',
    fail: 'Fail',
  },
};

// Share
export const SHARE: MixpanelEvent = { eventName: 'Share' };
export const INVITE_BUTTON: MixpanelEvent = { eventName: 'Click on invite button' };
export const INVITE_MEMBER: MixpanelEvent = { eventName: 'Invite member' };

// Embed
export const EMBED: MixpanelEvent = {
  eventName: 'Embed Code Copied',
  from: 'Editor Top Menu',
  location: 'Embed Panel',
  shareMethod: 'Embed',
};
export const EMBED_TOGGLE: MixpanelEvent = {
  eventName: 'Embed Feature is Toggled',
  from: 'Editor Top Menu',
  location: 'Embed Panel',
};

export const ICONS_SEARCH: MixpanelEvent = {
  eventName: 'Icons searched',
};

export const PHOTOS_SEARCH: MixpanelEvent = {
  eventName: 'Photos searched',
};

export const GIFS_SEARCH: MixpanelEvent = {
  eventName: 'GIFS searched',
};

export const TEMPLATES_SEARCH: MixpanelEvent = {
  eventName: 'Templates searched',
};

export const MAPS_SEARCH: MixpanelEvent = {
  eventName: 'Maps searched',
};

export const TEMPLATES_FILTERED: MixpanelEvent = {
  eventName: 'Editor Templates Filtered',
  filterName: {
    // plan type
    Free: 'Free',
    Premium: 'Premium',
    Business: 'Business',

    // page size
    Letter: 'Letter',
    Legal: 'Legal',
    Tabloid: 'Tabloid',
    Presentation: 'Presentation',
    Custom: 'Custom',
    Square: 'Square',

    // orientation
    Portrait: 'Portrait',
    Landscape: 'Landscape',

    // other
    Accessible: 'Accessible',
    Interactive: 'Interactive',
  },
};

export const PAGE_NUMBER_ENABLED: MixpanelEvent = { eventName: 'Page Number Enabled' };
export const PAGE_NUMBER_DISABLED: MixpanelEvent = { eventName: 'Page Number Disabled' };

export const PAGE_GUIDE: MixpanelEvent = {
  eventName: 'Page Guide Applied',
  type: {
    Margin: 'Margin',
    Grid: 'Grid',
    PrintBleed: 'Print Bleed',
  },
};

export const DESIGNAI_TEXT_GENERATED: MixpanelEvent = { eventName: 'DesignAI Text Generated' };
export const DESIGNAI_TEXT_GENERATED_ERROR: MixpanelEvent = { eventName: 'DesignAI Text Generation Error' };
export const DESIGNAI_TEXT_GENERATION_STOPPED: MixpanelEvent = { eventName: 'DesignAI Text Generation Stopped' };
export const DESIGNAI_TEXT_GENERATION_DISCARDED: MixpanelEvent = { eventName: 'DesignAi Text Generation Discarded' };
export const DESIGNAI_TEXT_REPLACED: MixpanelEvent = { eventName: 'DesignAI Text Replaced' };
export const DESIGNAI_TEXT_ADDED: MixpanelEvent = { eventName: 'DesignAI Text Added' };
export const DESIGNAI_TEXT_GENERATOR_OPENED: MixpanelEvent = { eventName: 'DesignAI Text Generator Opened' };

export const DESIGNAI_TEXT_UPGRADE: MixpanelEvent = {
  eventName: 'DesignAI Upgrade Clicked',
  from: {
    Modal: 'Upgrade Modal',
  },
};

export const CLICK_ON_PAID_FEATURE: MixpanelEvent = {
  eventName: 'Click On Paid Feature',
  feature: {
    CustomFont: 'Custom Font',
    Signature: 'Signature',
  },
};

// CREATE NEW FROM EDITOR
// Event named passed to E1 backend
export const CREATE_FROM_BLANK: MixpanelEvent = {
  eventName: 'Create Blank From Editor',
};

// Event triggered by frontend
export const CREATE_NEW_DESIGN: MixpanelEvent = {
  eventName: 'Create New from Editor',
  from: {
    Template: 'template',
    Blank: 'blank',
    DesignAI: 'designAI',
  },
};

/// COPY EVENT
// Event name passed to E1 backend
export const COPY_FROM_EDITOR: MixpanelEvent = {
  eventName: 'Copy From Editor',
};

// Event triggered by frontend
export const SAVE_AS_COPY_FROM_EDITOR: MixpanelEvent = {
  eventName: 'Save as Copy from Editor',
};

export const SCREENSHOT_CAPTURED: MixpanelEvent = { eventName: 'Screenshot Captured' };

export const USER_ACTION: MixpanelEvent = {
  eventName: 'Profile menu clicked',
  from: {
    myDesigns: 'My Designs',
    myAccount: 'My Account',
    signOut: 'Sign Out',
  },
};

export const HELP_LINK: MixpanelEvent = {
  eventName: 'Help menu clicked',
  from: {
    helpCenter: 'Help Center',
    keyboardShortcuts: 'Keyboard Shortcuts',
    emailUs: 'Email Us',
    chatWithUs: 'Chat with us',
  },
};

export const DATATABLE_EXPAND: MixpanelEvent = {
  eventName: 'Chart data table expanded',
};

export const DATATABLE_COLLAPSE: MixpanelEvent = {
  eventName: 'Chart data table collapsed',
};

export const PRIVATE_LINK_LOADED: MixpanelEvent = {
  eventName: 'Load Private Link',
};

export const FLIPBOOK_LINK_LOADED: MixpanelEvent = {
  eventName: 'Load Flipbook Link',
};

export const RESPONSIVE_LINK_LOADED: MixpanelEvent = {
  eventName: 'Load Responsive Link',
};

export const EMBED_LINK_LOADED: MixpanelEvent = {
  eventName: 'Load Embed Link',
};

export const LINK_VIEWED: MixpanelEvent = {
  eventName: 'Share Link Viewed',
  type: {
    private: 'Private',
    flipbook: 'Flipbook',
    responsive: 'Responsive',
    publish: 'Publish',
  },
};

export const LEFT_MENU_OPENED: MixpanelEvent = {
  eventName: 'Editor Left Menu Opened',
  from: {
    Replace: 'Replace',
    LeftPanel: 'Left Panel',
  },
  type: {
    BrandKit: 'Brand Kit',
    Template: 'Template',
    Text: 'Text',
    Shape: 'Shape',
    Icon: 'Icon',
    Image: 'Image',
    Upload: 'Upload',
    Chart: 'Chart',
    Map: 'Map',
    Elements: 'Elements',
  },
};

export const BACKGROUND_REMOVED: MixpanelEvent = {
  eventName: 'Image Background Removed',
};

export const PAGE_MANAGER_OPENED: MixpanelEvent = {
  eventName: 'Page Manager Opened',
};

export const PAGE_VIEW: MixpanelEvent = {
  eventName: 'Page View',
};

export const OPEN_TEMPLATE_PREVIEW: MixpanelEvent = {
  eventName: 'Open Template Preview',
};

export const CLICK_ICP_RECOMMENDATION_TOPIC: MixpanelEvent = {
  eventName: 'Click ICP Recommendation Topic',
  from: {
    key: 'from',
    value: {
      HRDashboard: 'hr dashboard',
      Calendar: 'calendar',
    },
  },
  topicTitle: {
    key: 'topic_title',
    value: '', // e.x: Independence Day
  },
};

export const CLICK_ON_CREATE: MixpanelEvent = {
  eventName: 'Click On Create From HR Dashboard',
  templateId: {
    key: 'template_id',
    value: '',
  },
};

export const SEE_MORE_TEMPLATES: MixpanelEvent = {
  eventName: 'Click On See More Templates',
  from: {
    HRDashboard: 'hr dashboard event grid',
    HRDashboardCategoryRow: 'hr dashboard category row',
  },
  topicTitle: {
    key: 'topic_title',
    value: '', // e.x: Independence Day
  },
};

export const CLICK_TOPIC_CATEGORY_CARD: MixpanelEvent = {
  eventName: 'Click Topic Category Card',
  to: {
    key: 'to',
    value: '', // e.x: /hr-teams/processes-and-policies
  },
};

export const CLICK_TOPIC_SUBCATEGORY_MENU: MixpanelEvent = {
  eventName: 'Click Topic Subcategory Menu',
  to: {
    key: 'to', // e.x: /hr-teams/processes-and-policies/onboarding
  },
};

export const CREATE_HR_CALENDAR_STATIC_PAGE: MixpanelEvent = {
  eventName: 'Click Create From HR Calendar Static Page',
};
export const SEE_MORE_HR_CALENDAR_STATIC_PAGE: MixpanelEvent = {
  eventName: 'Click See More Templates From HR Calendar Static Page',
};
export const CLICK_BRAND_TEMPLATES_SWITCH_LANDING_PAGE: MixpanelEvent = {
  eventName: 'Click Autobrand Switch From HR Calendar Static Page',
};
export const FETCH_AUTOBRAND: MixpanelEvent = {
  eventName: 'Brand Fetched',
  feature: {
    key: 'Feature',
    hrStaticSite: 'HR Calendar Static Page',
  },
};

export const CLICK_NAVBAR_LINK: MixpanelEvent = {
  eventName: 'Click Navbar Link',
  from: {
    key: 'from',
    HRDashboard: 'hr dashboard',
  },
  to: {
    key: 'to',
    value: '', // e.x: /templates
    Home: 'home',
    Templates: 'templates',
    HRDashboard: 'hr dashboard',
  },
};

export const CLICK_BRAND_TEMPLATES_SWITCH: MixpanelEvent = {
  eventName: 'Click Brand Templates Switch',
  value: {
    key: 'value',
  },
};

export const WIDGET_INTERACTION_CREATED: MixpanelEvent = {
  eventName: 'Widget Interaction Created',
  interactionType: {
    Expandable: 'Expand',
    Label: 'Label',
  },
};

export const WIDGET_INTERACTION_DELETED: MixpanelEvent = {
  eventName: 'Widget Interaction Deleted',
  interactionType: {
    Expandable: 'Expand',
    Label: 'Label',
  },
};

export const WIDGET_INTERACTION_EDITED: MixpanelEvent = {
  eventName: 'Widget Interaction Edited',
  interactionType: {
    Expandable: 'Expand',
    Label: 'Label',
  },
};

export const INTERACTION_PREVIEWED: MixpanelEvent = {
  eventName: 'Interaction previewed',
};

export const INTERACTION_TRIGGERED: MixpanelEvent = {
  eventName: 'Interaction triggered',
  interactionType: {
    Expandable: 'Expand',
    Label: 'Label',
  },
};

export const TRANSFORM_TRACK: MixpanelEvent = {
  eventName: 'Object Transformed',
};

export const INTERACTION_SUBMISSION_DOWNLOAD: MixpanelEvent = { eventName: 'Interaction submission download' };
export const INTERACTION_SUBMISSION_SUBMITTED: MixpanelEvent = { eventName: 'Interaction submission submitted' };
export const INTERACTION_SUBMISSION_ENABLED: MixpanelEvent = { eventName: 'Interaction submission enabled' };

export const DOWNLOAD_PERMISSION: MixpanelEvent = { eventName: 'Toggle download' };
export const PASSWORD_PERMISSION: MixpanelEvent = { eventName: 'Toggle password' };
export const INSIGHTS_MENU: MixpanelEvent = { eventName: 'View Insights' };

export const PAGE_DUPLICATED: MixpanelEvent = {
  eventName: 'Page Duplicated',
  from: {
    multiPageMenu: 'Multipage Menu',
  },
  type: {
    duplicate: 'Duplicate',
  },
};

export const SHARE_TAB_OPENED: MixpanelEvent = {
  eventName: 'Share Tab Opened',
  type: {
    private: 'Private Link',
    secure: 'Responsive Link',
    QRCode: 'QR Code',
    flipBook: 'Flip Book',
    fillableForm: 'Fillable Form',
  },
};

export const CTA_AI_TOOLS: MixpanelEvent = {
  eventName: 'Click CTA on AI Tools',
  type: {
    creditsSignup: 'Credits Sign Up',
  },
};

export const AI_TOOLS_GENERATOR_CATEGORY: MixpanelEvent = {
  eventName: 'Click on Generator Category',
};

export const APP_CRASHED: MixpanelEvent = {
  eventName: 'App Crashed',
};

export const RELOAD_ON_IMPORT_FAIL: MixpanelEvent = {
  eventName: 'Reload On Import Fail',
};

export const DESIGN_AI_FEEDBACK: MixpanelEvent = {
  eventName: 'Design AI Feedback',
};

export const PAGE_ORIENTATION: MixpanelEvent = {
  eventName: 'Page Orientation',
};

export const AI_IMAGE_TAB_OPENED: MixpanelEvent = {
  eventName: 'AI Image Tab Opened',
};

export const AI_IMAGE_STYLE_APPLIED: MixpanelEvent = {
  eventName: 'AI Image Style Applied',
};

export const AI_IMAGE_GENERATED: MixpanelEvent = {
  eventName: 'AI Image Generated',
  from: {
    editor: 'Editor',
    aiTools: 'AI Tools',
  },
};

export const AI_IMAGE_GENERATED_ERROR: MixpanelEvent = {
  eventName: 'AI Image Generated Error',
};

export const AI_IMAGE_FEEDBACK: MixpanelEvent = {
  eventName: 'AI Image Feedback',
};
